import React from "react";

export default function AdmStart() {
  return <div>AdmStart</div>;
}
